export default __webpack_public_path__ + "static/media/FrameDonja.4ebfcd6d.svg";